import { Box } from '@chakra-ui/react'
import React from 'react'
import DrawerWrapper from '../DrawerWrapper/DrawerWrapper'

export interface TrackDrawerProps {
  isDrawerVisible: boolean
  hideDrawer: () => void
  trackingLink: string
}

const TrackDrawer = ({ isDrawerVisible, hideDrawer, trackingLink }: TrackDrawerProps) => {
  return (
    <DrawerWrapper onClose={hideDrawer} isVisible={isDrawerVisible}>
      <Box flex='1' display='flex' marginTop={50}>
        <iframe
          src={trackingLink}
          title='Tracking Broadcast'
          style={{ width: '100%', height: '100%', border: 'none' }}
          frameBorder='0'
        />
      </Box>
    </DrawerWrapper>
  )
}

export default TrackDrawer
